var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66675 6.33333V4.33333C3.66675 2.49238 5.15913 1 7.00008 1C8.61272 1 9.95789 2.14517 10.2667 3.66667M4.86675 13H9.13341C10.2535 13 10.8136 13 11.2414 12.782C11.6177 12.5903 11.9237 12.2843 12.1154 11.908C12.3334 11.4802 12.3334 10.9201 12.3334 9.8V9.53333C12.3334 8.41323 12.3334 7.85318 12.1154 7.42535C11.9237 7.04903 11.6177 6.74307 11.2414 6.55132C10.8136 6.33333 10.2535 6.33333 9.13341 6.33333H4.86675C3.74664 6.33333 3.18659 6.33333 2.75877 6.55132C2.38244 6.74307 2.07648 7.04903 1.88473 7.42535C1.66675 7.85318 1.66675 8.41323 1.66675 9.53333V9.8C1.66675 10.9201 1.66675 11.4802 1.88473 11.908C2.07648 12.2843 2.38244 12.5903 2.75877 12.782C3.18659 13 3.74664 13 4.86675 13Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.58dbf587a102b3b0b7ae6d6bf8db3a25.svg";
export { ForwardRef as ReactComponent };